import { createActions, handleActions } from 'redux-actions';
import { asyncActions, asyncReducer, asyncSelector, asyncDefaultState } from './common/async';

const collection = 'onboarding';

const defaultState = {
  ...asyncDefaultState(),
};

const options = {
  prefix: collection,
};

const actions = createActions(
  {
    ...asyncActions,
  },
  options,
);

const reducer = handleActions(
  {
    ...asyncReducer(),
  },
  defaultState,
  options,
);

const selectors = {
  ...asyncSelector(collection),
};

export { actions, selectors, reducer as default };
